import React from 'react';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const ListValues = ({ values, classes, translate }) => (
  Array.isArray(values)
    ? values.map((item) => {
      if (item.nationalIdNumber) {
        return (
          <Typography key={JSON.stringify(item)} variant="body1">
            <span className={classes.bold}>
              {`${item.firstName} ${item.lastName}: `}
            </span>
            {item.influence}
          </Typography>

        );
      }
      return (
        <Typography
          key={JSON.stringify(item)}
          variant="body1"
          onClick={item.onClick || null}
          className={clsx(item.onClick && classes.onclick)}
        >
          {item.text || item}
        </Typography>
      );
    })
    : Object.keys(values).filter(key => values[key]).map(key => (
      <Typography key={key} variant="body1">
        <span className={classes.bold}>
          {`${translate(`listValues.${key}`)}: `}
        </span>
        {values[key]}
      </Typography>
    ))
);

const styles = theme => ({
  bold: {
    fontWeight: 'bold',
  },
  onclick: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.primary.dark,
      cursor: 'pointer',
    },
  },
});

const mapStateToProps = ({ localize }) => ({ translate: getTranslate(localize) });

export default connect(mapStateToProps)(withStyles(styles)(ListValues));
